// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { PersistentObject } from '../../../SagaBase/PersistentObject';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ListVehicleKinds_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.ListObjects.ListVehicleKinds';
  $t: string = 'SagaSchema.ListObjects.ListVehicleKinds';

  public static GetMembers(): string[] {
    return ['VehicleKindId', 'VehicleKind', 'Description', 'Deleted', 'Priority'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return ListVehicleKinds_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public VehicleKindId: number = 0;
  public VehicleKind: string;
  public Description: string;
  public Deleted: boolean = false;
  public Priority: number = 0;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.VehicleKindId;
  }
  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
